var app = angular.module("leonardo");

var ReportFormController = function($scope, $controller, $state, $rootScope, $filter, ngDialog, QuickReportsService,
                                    ReportService, FilterService, ScheduleService, NotificationService, AuthDataService,
                                    $timeout, PropertyGroupService, PermissionService, AccountUserService, $q) {

  $scope.report = $scope.$parent.report ?
    $scope.$parent.report : {filters: {}, name: '', report_type: null, only_superuser: $state.current.superuser};

  $scope.system = $scope.$parent.mode === 'system';

  QuickReportsService.get($scope.$parent.report.id).then(function(data) {
    if (data) {
      $rootScope.$broadcast('no_reset_filters:updated', true);
      FilterService.clearFilters(true, null, 'filters_report');
      var filters = [];
      var working_days = [];
      angular.forEach(data.filters, function(filter, key) {
        if (key === 'account') {
          FilterService.setFilter('account_reports', filter, true);
          filters.push('account_reports');
        }
        else if (key === 'managed_by') {
          FilterService.setFilter('managed_by_reports', filter, true);
          filters.push('managed_by_reports');
        }
        else if (key === 'group') {
          FilterService.setFilter('group_reports', filter, true);
          filters.push('group_reports');
        }
        else if (key === 'portfolio') {
          FilterService.setFilter('portfolio_reports', filter, true);
          filters.push('portfolio_reports');
        }
        else if (key === 'property') {
          FilterService.setFilter('property_reports', filter, true);
          filters.push('property_reports');
        }
        else if (_.contains(['fields', 'fields_to_show', 'fieldsToShow', 'dynamic_fields'], key)) {
          FilterService.setFilter('fields_active', filter, true);
          filters.push('fields_active');
        }
        else if (key.includes('working_days_')) {
          working_days.push(key);
        }
        else {
          // Handle date range filters
          if (key === 'created_date_range') {
            // Set the date range first
            FilterService.setFilter(key, filter, true);
            filters.push(key);
            // Set the from/to dates to null to prevent them from being added back
            FilterService.setFilter('created_from_date', null, true);
            FilterService.setFilter('created_to_date', null, true);
          } else {
            FilterService.setFilter(key, filter, true);
            filters.push(key);
          }
        }
      });
      switch (data.report_type.toString()) {
        case ReportService.TYPE_ACTION_ITEM:
          $controller('ReportsListFilters', { $scope: $scope });
          break;
        case ReportService.TYPE_ACTIVITY:
          $controller('ReportsActivityListFilters', { $scope: $scope });
          break;
        case ReportService.TYPE_BILLING:
          $controller('ReportsBillingListFilters', { $scope: $scope });
          break;
        case ReportService.TYPE_MISSING_DOCUMENTS:
        case ReportService.TYPE_EXISTING_DOCUMENTS:
          $controller('ReportsDocumentListFilters', { $scope: $scope });
          break;
        case ReportService.TYPE_DYNAMIC_FORM:
          $controller('ReportsDynamicFormListFilters', { $scope: $scope });
          break;
        case ReportService.TYPE_DYNAMIC_FORM_STATISTIC:
          $controller('ReportsStatisticListFilters', { $scope: $scope });
          break;
        case ReportService.TYPE_ON_DEMAND_INSTRUCTION:
          $controller('ReportsOnDemandListFilters', { $scope: $scope });
          break;
        case ReportService.TYPE_PROPERTY:
          $controller('ReportsPropertyListFilters', { $scope: $scope });
          break;
        case ReportService.TYPE_PROPERTY_AMENITIES:
          $controller('ReportsPropertyAmenitiesListFilters', { $scope: $scope });
          break;
        case ReportService.TYPE_TEMPLATE:
          $controller('ReportsTemplateListFilters', { $scope: $scope });
          break;
        case ReportService.TYPE_UNIT:
          $state.current.by_unit = true;
          $controller('ReportsWorkflowListFilters', { $scope: $scope, $state: $state });
          break;
        case ReportService.TYPE_WORKFLOW:
          $state.current.by_unit = false;
          $controller('ReportsWorkflowListFilters', { $scope: $scope, $state: $state });
          break;
        case ReportService.TYPE_USER:
          $controller('ReportsUserListFilters', { $scope: $scope });
          break;
        case ReportService.TYPE_WORK_ORDERS:
          $controller('ReportsWorkOrdersFilters', { $scope: $scope });
          break;
        case ReportService.TYPE_CONTACT:
          $controller('ReportsContactListFilters', { $scope: $scope });
          break;
        case ReportService.TYPE_MIMO:
          $controller('ReportsMimoListFilters', { $scope: $scope });
          break;
      }
      $q.when($scope.initOptions()).then(function () {
        if (working_days.includes('working_days_all')) {
          working_days = $scope.workingDays.map((item) => item.id);
        }
        if (working_days.length > 0) {
          FilterService.setFilter('working_days', working_days.join(','), true);
          filters.push('working_days');
        }
        $scope.report = data;
        $timeout(function () {
          FilterService.setFilter('filters_report', filters);
        }, 100);
      });
    }
  });

  //TODO: we can remove this if not being used anymore
  $scope.reportOwner = function() {
    if (!$scope.report) {
      return false;
    }
    else if (!$scope.report.account) {
      return AuthDataService.isAdmin() || ($scope.report.white_label && AuthDataService.isWhiteLabelAdmin());
    }
    else if ($scope.report.account_user) {
      return $scope.report.account_user.id === AccountUserService.currentAccountUser.id;
    }
  };

  $scope.accountOwner = function() {
    if (!$scope.report) {
      return false;
    }

    else if (!$scope.report.account) {
      return AuthDataService.isAdmin() || ($scope.report.white_label && AuthDataService.isWhiteLabelAdmin());
    }
    else if(PermissionService.isAccountOwner()) {
      return true;
    }
    else if ($scope.report.account_user) {
      return $scope.report.account_user.id === AccountUserService.currentAccountUser.id;
    }
  
  };

  $scope.showScheduleAddDialog = function () {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/report/add-schedule.html',
      className: 'ngdialog-theme-default ngdialog-schedules',
      controller: 'ScheduleAddDialog',
      data: {
        report: $scope.report
      }
    }).then(function (result) {
      $scope.report = result;
    });
  };

  $scope.showSaveReport = function () {
    if (FilterService.hasFilter('group_by') && FilterService.getFilter('group_by') === 'group') {
      if (FilterService.hasFilter('group_reports')) {
        var groups_Ids = FilterService.getFilter('group_reports').toString().split(',');
        if (groups_Ids.length > 1) {
          PropertyGroupService.getGroups(groups_Ids).then(function (data) {
            openSaveReport(data);
          });
        }
        else {
          $scope.saveReport();
        }
      }
      else {
        PropertyGroupService.getGroups().then(function (data) {
          openSaveReport(data);
        });
      }
    }
    else {
      $scope.saveReport();
    }
  };

  function openSaveReport(data) {
    if (data) {
      ngDialog.open({
        template: 'views/templates/dialog/report/group-error.html'
      });
    }
    else {
      $scope.saveReport();
    }
  }

  $scope.saveReport = function() {
    let filters = $scope.report.filters;
    $scope.report.filters = $scope.getValidFilters();
    if($scope.report.report_type == ReportService.TYPE_PROPERTY_AMENITIES) {
      $scope.report.filters['detailed'] = filters['detailed'];
    }
    if (!$scope.accountOwner()) {
      ngDialog.openConfirm({
        template: 'views/templates/dialog/report/add-report.html',
        controller: 'ReportDialog',
        data: {
          report_type: $scope.report.report_type,
          filters: $scope.report.filters,
          schedule: $scope.report.schedule,
          only_superuser: $scope.report.only_superuser
        }
      }).then(function(){
        NotificationService.notify('success', $filter('translate')('The report has been saved successfully'));
        if (AuthDataService.isNotStaff()) {
          $timeout(function () {
            $state.go('reports.my-reports');
          }, 100);
        }
        else {
          if ($state.$current.name === 'reports.admin-quick') {
            $rootScope.$broadcast('report:updated');
          }
          else {
            $timeout(function () {
              $state.go('reports.admin-quick');
            }, 100);
          }
        }
      });
    }
    else {
      angular.forEach($scope.report.schedule, function(value){
        if (value.account_user) {
          value.account_user = value.account_user.id ? value.account_user.id : value.account_user;
        }
        if (value.id){
          if (!isEmpty(value.contact_types)) {
            var contact_types = [];
            angular.forEach(value.contact_types, function(contact_type) {
              contact_types.push(contact_type.id ? contact_type.id : contact_type);
            });
            value.contact_types = contact_types;
          }
          ScheduleService.one(value.id).patch(value);
        }
        else {
          value.quick_report = $scope.report.id;
          ScheduleService.post(value);
        }
      });
      $scope.report.patch({
        filters:$scope.report.filters,
        name: $scope.report.name,
        only_superuser: $scope.report.only_superuser,
        shared: $scope.report.shared
      }).then(function() {
        NotificationService.notify('success', $filter('translate')('The report has been saved successfully'));
        $rootScope.$broadcast('report:updated');
      });
    }
  };

  $scope.isPropertyAttributeReport = function () {
    if (!$scope.report) {
      return false;
    }
    return $scope.report.report_type == ReportService.TYPE_PROPERTY_AMENITIES;
  }

};

app.controller('ReportFormController', ['$scope', '$controller', '$state', '$rootScope', '$filter', 'ngDialog',
  'QuickReportsService', 'ReportService', 'FilterService', 'ScheduleService', 'NotificationService', 'AuthDataService',
  '$timeout', 'PropertyGroupService', 'PermissionService', 'AccountUserService', '$q', ReportFormController]);
